import { fromJS } from 'immutable';
import { createReducer } from 'redux-create-reducer';
import * as actions from './actions';

/**
 * Include here any default messages that are required
 * in case content can't be loaded (i.e. messages for
 * loading, errors, etc).
 */
export const initialState = fromJS({
  external_content: {
    loadingMsg: 'Loading...'
  }
});

export default createReducer(initialState, {
  [actions.FETCH_CONTENT]: state => state.set('loading', true),
  [actions.FETCH_CONTENT_FAILED]: (state, action) =>
    state.set('loading', false).set('error', action.error),
  [actions.FETCH_CONTENT_SUCCESS]: (state, action) =>
    state.set('loading', false).set('external_content', fromJS(action.payload))
});
